import React, { Component } from "react";
import { connect } from "react-redux";
import { css } from "aphrodite";
import CardLaporanDanaSHU from
  "../../components/dasboard/CardLaporanDanaSHU";
import CardKoperasiPokok from
  "../../components/dasboard/CardKoperasiPokok";
import CardKoperasiWajib from
  "../../components/dasboard/CardKoperasiWajib";
import CardKoperasiCash from
  "../../components/dasboard/CardKoperasiCash";
import CardKoperasi from "../../components/dasboard/CardKoperasi";
import { dashboardGridStyles as s } from
  "../../components/dasboard/dashboardGridStyles";

class DashboardAdminKoperasi extends Component {
  render() {
    return (
      <>
        <div className={css(s.row)}>
          <CardKoperasiPokok />
          <CardKoperasiWajib />
          <CardKoperasiCash />
        </div>
        <div className={css(s.row)}>
          <div className={css(s.col100)}>
            <CardKoperasi />
          </div>
        </div>
        <CardLaporanDanaSHU />
      </>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(
  DashboardAdminKoperasi
);
